import { TrackchangesOutlineIcon } from '@carboncopyco/icons';
import type { IDynamicEditData } from '@carboncopyco/types';
import { ModificationItem } from './ModificationItem';
import { getListLabel } from './utils';

export const ListModificationItem = ({
  edit,
}: {
  edit: IDynamicEditData['element'];
}) => {
  return (
    <ModificationItem>
      <ModificationItem.Content>
        <ModificationItem.Icon>
          <TrackchangesOutlineIcon size={18} />
        </ModificationItem.Icon>
        <ModificationItem.Text label={getListLabel(edit)} />
      </ModificationItem.Content>
    </ModificationItem>
  );
};
